import React from "react";
import PropTypes from "prop-types";
import { Redirect, useLocation } from "react-router-dom";

/**
 * RequirePasswordChanged Guard
 * 
 * Rules:
 * 1. If mustChangePassword is true and current route is NOT /change-password, redirect to /change-password.
 * 2. If mustChangePassword is false and user attempts to access /change-password, redirect to /dashboard.
 * 3. If accessing /change-password without an active token/session, redirect to /login.
 */
const RequirePasswordChanged = ({ children, isAuthProtected }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const token = localStorage.getItem("token");
  const mustChange = localStorage.getItem("mustChangePassword") === "true";

  // If unauthenticated on forced change-password route, send to login
  if (currentPath === "/change-password" && !token) {
    return <Redirect to="/login" replace />;
  }

  // If on /change-password but password change is NOT required, redirect to dashboard
  if (currentPath === "/change-password" && !mustChange) {
    return <Redirect to="/dashboard" replace />;
  }

  // If user has mustChangePassword=true, block access to all other protected routes
  if (isAuthProtected && token && mustChange && currentPath !== "/change-password") {
    return <Redirect to="/change-password" replace />;
  }

  return children;
};

RequirePasswordChanged.propTypes = {
  children: PropTypes.node.isRequired,
  isAuthProtected: PropTypes.bool,
};

export default RequirePasswordChanged;
